module.exports = __webpack_public_path__ + "img/product2.892a992d.png";